import { useEffect } from 'react';
import { yAxisScalingLabels } from '../constants';
import { YAxisScalingOption } from '../constants';
import type { RawSeriesData } from '../types';

interface UseDownloadDataProps {
  seriesData: RawSeriesData[] | undefined;
  tradeDirectionSelector: string;
  yAxisScalingOption: YAxisScalingOption;
  dataRef: React.MutableRefObject<Record<string, unknown>[]>;
}

export const useDownloadData = ({
  seriesData,
  tradeDirectionSelector,
  yAxisScalingOption,
  dataRef,
}: UseDownloadDataProps) => {
  useEffect(() => {
    const valueKey =
      tradeDirectionSelector === 'exportValue'
        ? 'gross exports'
        : 'gross imports';
    const scalingLabel = yAxisScalingLabels[yAxisScalingOption] ?? yAxisScalingOption;
    if (seriesData && seriesData?.length) {
      const downloadData = [];
      seriesData.forEach((series) => {
        const {
          nameEn,
          key,
          seriesData = [],
          topLevelParentName,
          productCode,
        } = series;

        seriesData.forEach((rawD) => {
          const d = rawD as [number, number] & { data: { year: number } };
          const actualValue = d[1] - d[0];

          const downloadDatum = {
            Name: nameEn,
            Code: key,
            year: d.data.year,
            [`${scalingLabel} ${valueKey}`]: actualValue,
          };
          if (topLevelParentName) {
            downloadDatum.Sector = topLevelParentName;
          }
          if (productCode) {
            downloadDatum.Code = productCode;
          }
          downloadData.push(downloadDatum);
        });
      });
      dataRef.current = downloadData;
    }
  }, [seriesData, dataRef, tradeDirectionSelector, yAxisScalingOption]);
};

